import { render, staticRenderFns } from "./Highscores.vue?vue&type=template&id=a090161e&"
import script from "./Highscores.vue?vue&type=script&lang=js&"
export * from "./Highscores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports